<template>
  <main class="pt-20 md:pt-[12.5vw] lg:pt-[5vw] bg-white min-h-screen">
    <div class="container-1 pt-6 md:pt-[7.2vw] lg:pt-[3vw] pb-24">
      <h1 class="figtree font-semibold text-2xl md:text-[2.5rem] lg:text-[2vw] text-ip-color-3">{{ pageLang.title[lang] }}</h1>
      <div class="hidden flex flex-col md:flex-row justify-between mt-0 md:mt-[3.1vw] lg:mt-[2vw] gap-4 md:gap-[3.125vw] lg:gap-[1.25vw]">
        <div v-if="!fetching" class="flex gap-3 md:gap-[1.5vw] lg:gap-[0.625vw] carousel pb-0 md:pb-[1.5vw] lg:pb-[0.625vw] order-1 md:order-0">
          <button class="carousel-item btn btn-primary rounded-full text-base md:text-[2vw] lg:text-[.8vw] font-normal figtree">{{ linkLang.firstButton[lang] }}</button>
          <NuxtLink v-for="cat in catBlogData"
          :key="cat"
          class="carousel-item btn rounded-full text-base md:text-[2vw] lg:text-[.8vw] font-normal figtree hover:shadow-sm"
          :to="`${lang == 'id' ? `/insights/category/${cat.slug[lang]}`: `/${lang}/insights/category/${cat.slug[lang]}`}`"
          >{{ cat.name[lang] }}</NuxtLink>
        </div>
        <div v-else class="flex gap-3 md:gap-[1.5vw] lg:gap-[0.625vw] carousel pb-0 md:pb-[1.5vw] lg:pb-[0.625vw] order-1 md:order-0">
          <div class="carousel-item btn !bg-gray-200 !border-none !outline-none rounded-full text-base md:text-[2vw] lg:text-[.8vw] font-normal figtree animate-pulse-opacity"><span class="invisible">placeholder</span></div>
          <div v-for="i in 4" :key="i"
          class="animate-pulse-opacity carousel-item btn !bg-gray-200 !border-none !outline-none rounded-full text-base md:text-[2vw] lg:text-[.8vw] font-normal figtree hover:shadow-sm"
          ><span class="invisible">placeholder</span></div>
        </div>
        <div class="md:pb-3 order-0 md:order-1"></div>
      </div>

      <div v-if="!fetching" class="mt-6 md:mt-[6.25vw] lg:mt-[2.5vw]"
        data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="300"
      >
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-[3.125vw] lg:gap-[1.25vw]" v-if="blogData && blogData.length > 0">
          <InsightCard v-for="item in blogData" :item="item" :key="item.id"/>
        </div>
        <div v-else>
          <h2 class="figtree text-base md:text-[2vw] lg:text-[.8vw] text-[#374151]">There is no post on this category</h2>
        </div>
      </div>
      <div v-else class="mt-6 md:mt-[6.25vw] lg:mt-[2.5vw]">
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-[3.125vw] lg:gap-[1.25vw]">
          <InsightCardPlaceholder v-for="item in 2" :item="item" :key="item.id"/>
        </div>
      </div>

      <div class="flex justify-center" v-if="isThereMoreData">
        <button class="btn" @click="loadMore()">{{ buttonTextMore[lang] }}</button>
      </div>
    </div>
  </main>
</template>

<script setup>
 
 
const lang = ref('id')
const config = useRuntimeConfig();
const keyword = ref('');

definePageMeta({
  layout: 'home-layout',
});
const dayjs = useDayjs();

const pageLang = ref({
  title: {
    id: 'Explore Our Insights',
    en: 'Explore Our Insights',
  },
});

const linkLang = ref({
  firstButton: {
    id: 'All',
    en: 'All',
  },
});

const currentPage = ref(1);
const firstDocSnapshot = ref(null);
const lastDocSnapshot = ref(null);
const totalRows = ref(0);
const articlesSize = ref(0);
const isThereMoreData = ref(0);
const limit = ref(6);
const lastPage = computed(() => {
  return Math.floor(totalRows.value / limit.value);
});
const fetching = ref(true);

const catBlogData = ref([]);
const blogData = ref([]);
const fetch = async () => {

  const { data: catBlogDoc } = await useAsyncData('AllBlogCatDoc', () => $fetch('/api/cms/blogs',
    {
      method: 'POST',
      body: {
        action: 'overview',
      },
    }
  ), {
    transform: (catBlogDoc) => catBlogDoc.result,
  });
  console.log(catBlogDoc.value);

  catBlogData.value = catBlogDoc.value.categories;
  if (catBlogData.value) {
    catBlogData.value.forEach(cat => {
      if (cat.posts) blogData.value.push(...cat.posts);
    });
  }

  if (totalRows.value === limit.value) {
    isThereMoreData.value = true;
  } else {
    isThereMoreData.value = false;
  }
  nextTick(() => {
    fetching.value = false;
  });
};
fetch();

const loadMore = async () => {
  const { data: blogDoc } = await useAsyncData('AllBlogDoc', () => $fetch(`/api/cms/blogs`,
    {
      method: 'POST',
      body: {
        action: 'load-more',
        lastDocumentSnapshot: lastDocSnapshot.value,
        currentPage: currentPage.value + 1,
        perPage: limit.value,
      },
    }
  ), {
    transform: (blogDoc) => blogDoc.result,
  });
  const newData = blogDoc.value.docs;
  newData.forEach(newBlog => {
    blogData.value.push(newBlog);
  });
  currentPage.value = blogDoc.value.currentPage ? blogDoc.value.currentPage : 1;
  firstDocSnapshot.value = blogDoc.value.firstDocSnapshot;
  lastDocSnapshot.value = blogDoc.value.lastDocSnapshot;
  totalRows.value = blogDoc.value.totalRows;
  articlesSize.value = blogDoc.value.articlesSize;

  if (articlesSize.value == limit.value) {
    isThereMoreData.value = true;
  } else {
    isThereMoreData.value = false;
  }
};

onMounted(() => {
});

onBeforeUnmount(() => {
});

watch(() => lang.value,
  (val) => {
    dayjs.locale(val);
  },
);
</script>

<style lang="scss" scoped>

</style>
